module.exports = __webpack_public_path__ + "img/book-open.907f34b0.svg";